// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.switch__sVmhuiKdBj label,.switch__sVmhuiKdBj label::before{cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/assets/components/settings/components/sections/satisfaction/components/common/GlobalCsatSwitch/components/index.module.scss"],"names":[],"mappings":"AACI,4DAEE,cAAA","sourcesContent":[".switch {\n    label,\n    label::before {\n      cursor: pointer;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `switch__sVmhuiKdBj`
};
export default ___CSS_LOADER_EXPORT___;
